import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Editorial footer slot. Mirrors the small centered footer at the
 * bottom of DashboardArchitecturePage — a hairline-bordered, muted
 * credit line with optional subline.
 */
export type EditorialFooterProps = {
  /** Primary line — usually the page identity, e.g. "כרטיסייה 001 · מסגרת חוסן". */
  primary: ReactNode;
  /** Optional small line under the primary. */
  secondary?: ReactNode;
  /** Extra classes on the wrapper. */
  className?: string;
};

export function EditorialFooter({
  primary,
  secondary,
  className,
}: EditorialFooterProps) {
  return (
    <footer
      className={cn(
        "mt-16 border-t border-stone-200 pt-7",
        "text-center text-[13px] text-stone-500",
        className,
      )}
    >
      <p className="m-0 mb-1">{primary}</p>
      {secondary ? (
        <p className="m-0 text-[12px] text-stone-400">{secondary}</p>
      ) : null}
    </footer>
  );
}
